export const messages = {
  en: {
    transferPartnerGoods: {
      title: 'Sync Products',
      productImage: 'Product Image',
      productId: 'ID',
      productName: 'Name',
      specification: 'Specification',
      stock: 'Stock',
      price: 'Price',
      operation: 'Operation',
      delete: 'Delete',
      cancel: 'Cancel',
      submit: 'Submit',
      selectProducts: 'Select Products',
      searchPlaceholder: 'Search product name',
      confirmClose: 'Confirm to close?',
      selectAtLeastOne: 'Please select at least one product',
      noDuplicateSelection: 'Do not select duplicate products',
      selectProductsFirst: 'Please select products first'
    }
  },
  zh: {
    transferPartnerGoods: {
      title: '同步商品',
      productImage: '商品图片',
      productId: '编号',
      productName: '名称',
      specification: '规格',
      stock: '库存',
      price: '单价',
      operation: '操作',
      delete: '删除',
      cancel: '取消',
      submit: '提交',
      selectProducts: '选择商品',
      searchPlaceholder: '搜索商品名称',
      confirmClose: '确认关闭？',
      selectAtLeastOne: '请至少选择一件商品',
      noDuplicateSelection: '请勿重复选择商品',
      selectProductsFirst: '请先选择商品'
    }
  }
}